import { render, staticRenderFns } from "./backoffice-gerenciar-cirurgia-conjunta.vue?vue&type=template&id=5f5739f8&scoped=true"
import script from "./backoffice-gerenciar-cirurgia-conjunta.vue?vue&type=script&lang=ts"
export * from "./backoffice-gerenciar-cirurgia-conjunta.vue?vue&type=script&lang=ts"
import style0 from "./backoffice-gerenciar-cirurgia-conjunta.vue?vue&type=style&index=0&id=5f5739f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5739f8",
  null
  
)

export default component.exports